import { MapPinIcon, BuildingStorefrontIcon, HomeIcon } from '@heroicons/react/24/outline'

const ShopLocation = ({
  shop,
  className = '',
  showIcons = true,
  layout = 'inline',
  iconColor = 'text-secondary-400',
}) => {
  if (!shop) return null

  const locationParts = []

  if (shop.shopNumber || shop.shopNumber === 0) {
    locationParts.push(`Shop ${shop.shopNumber}`)
  }

  if (shop.shopFloor || shop.floor || shop.shopFloor === 0 || shop.floor === 0) {
    const floorValue = shop.shopFloor ?? shop.floor
    locationParts.push(`${floorValue} Floor`)
  }

  if (shop.shopBuildingName || shop.buildingName) {
    const buildingName = shop.shopBuildingName || shop.buildingName
    locationParts.push(buildingName)
  }

  if (locationParts.length === 0) {
    return (
      <span className={`text-sm text-gray-400 italic ${className}`}>Location not available</span>
    )
  }

  const locationText = locationParts.join(', ')

  if (layout === 'stacked' && showIcons) {
    return (
      <>
        {(shop.shopBuildingName || shop.buildingName) && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <BuildingStorefrontIcon className={`w-4 h-4 ${iconColor}`} />
            <span>{shop.shopBuildingName || shop.buildingName}</span>
          </div>
        )}

        {(shop.shopFloor || shop.floor || shop.shopFloor === 0 || shop.floor === 0) && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <HomeIcon className={`w-4 h-4 ${iconColor}`} />
            <span>{shop.shopFloor ?? shop.floor} Floor</span>
          </div>
        )}

        {(shop.shopNumber || shop.shopNumber === 0) && (
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <MapPinIcon className={`w-4 h-4 ${iconColor}`} />
            <span>Shop {shop.shopNumber}</span>
          </div>
        )}
      </>
    )
  }

  return (
    <div className={`flex items-center gap-2 text-sm text-gray-600 ${className}`}>
      {showIcons && <MapPinIcon className={`w-4 h-4 ${iconColor} flex-shrink-0`} />}
      <span className="truncate" title={locationText}>
        {locationText}
      </span>
    </div>
  )
}

export default ShopLocation
